import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";
import { useLocation } from "react-router-dom";
import {
	SidebarMenuButton,
	SidebarMenuSub,
	SidebarMenuSubButton,
	SidebarMenuSubItem,
} from "@/shared/components/ui/Sidebar";
import { ChevronDown } from "lucide-react";
import { JSX } from "react";

const Collapsible = CollapsiblePrimitive.Root;

const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger;

const CollapsibleContent = CollapsiblePrimitive.CollapsibleContent;

export type CollapsibleSubmenuLink = {
	title: string;
	url: string;
	linkClasses?: string;
	icon?: JSX.Element;
};

function CollapsibleMenu({
	title,
	icon: Icon,
	links = [],
	openByDefault = false,
}: {
	title: string;
	icon: React.ElementType;
	links: CollapsibleSubmenuLink[];
	openByDefault?: boolean;
}) {
	const location = useLocation();
	// Check if any link matches the current URL (including query parameters)
	const isActive = links.some(link => {
		// Extract the base path and query parameter from the link URL
		const [linkPath, linkQuery] = link.url.split("?");
		// Extract the category from the query parameter
		const linkCategory = linkQuery?.split("=")[1];

		// Check if the current URL matches the link path and category
		const currentCategory = new URLSearchParams(location.search).get("category");
		return location.pathname === linkPath && currentCategory === linkCategory;
	});

	const defaultOpen = openByDefault || isActive;

	return (
		<Collapsible className="group/collapsible" defaultOpen={defaultOpen}>
			<CollapsibleTrigger className="flex w-full items-center justify-between gap-1 pb-1">
				<SidebarMenuButton asChild>
					<span>
						<Icon size={15} />
						<span>{title}</span>
					</span>
				</SidebarMenuButton>
				<ChevronDown className="ml-auto transition-transform group-data-[state=open]/collapsible:rotate-180" />
			</CollapsibleTrigger>
			<CollapsibleContent>
				<SidebarMenuSub>
					{links.map(link => {
						// Check if this specific link is active
						const [linkPath, linkQuery] = link.url.split("?");
						const linkCategory = linkQuery?.split("=")[1];
						const currentCategory = new URLSearchParams(location.search).get("category");
						const isLinkActive = location.pathname === linkPath && currentCategory === linkCategory;

						return (
							<SidebarMenuSubItem key={link.title}>
								<SidebarMenuSubButton asChild>
									<a href={link.url} className={isLinkActive ? "bg-[#004F8D] text-white" : (link?.linkClasses ?? "")}>
										<span>{link.title}</span>
									</a>
								</SidebarMenuSubButton>
							</SidebarMenuSubItem>
						);
					})}
				</SidebarMenuSub>
			</CollapsibleContent>
		</Collapsible>
	);
}

export { Collapsible, CollapsibleTrigger, CollapsibleContent, CollapsibleMenu };
